import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Helmet } from 'react-helmet-async'
import ImageHero from 'app/theme/ImageHero'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import Calculator from 'app/theme/calculator'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import getGoogleMetaTags from './occasionSEOData'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import filmProductionGrid1 from 'assets/img/film-production-grid-1.jpg'
import filmProductionGrid2 from 'assets/img/film-production-grid-2.jpg'
import filmProductionGrid3 from 'assets/img/film-production-grid-3.jpg'
import filmProductionGrid4 from 'assets/img/film-production-grid-4.jpg'
import filmProductionGrid5 from 'assets/img/film-production-grid-5.jpg'
import filmProductionGrid6 from 'assets/img/film-production-grid-6.jpg'
import filmProductionBanner from 'assets/img/film-production-catering-banner.jpg'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import { useInView } from 'react-intersection-observer'

export default function FilmProductionCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  const googleMetaTags = getGoogleMetaTags('filmProductionGeneral')

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Catering for TV and Film Production (Food Trucks) - Roaming Hunger</title>
        <meta name="description" content="Looking for flexible, mobile film production catering? Food trucks are a great way to provide TV/movie set catering across the country. Grab fun film catering" />
        <meta name="og:title" content="Catering for TV and Film Production (Food Trucks)" />
        <script type="application/ld+json">
          {googleMetaTags}
        </script>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={filmProductionBanner}
          title="TV & Film Catering"
          onButtonClick={openModal}
          description="Whether you're on the lot or on location, Roaming Hunger makes production catering turnkey with delicious food trucks."
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <IntroGrid />
      <FeaturedClients onButtonClick={openModal} />
      <WhyWorkWithUsGrid />
      <WhyWorkWithUs onButtonClick={openModal} />
      <CuisineTypes baseUrl='/food-truck-catering' />
      <HowItWorksGrid />
      <HowItWorks heading="How Production Catering Works" onButtonClick={openModal} />
      <HowItWorksLarge heading="How Production Catering Works" onButtonClick={openModal} />
      <Calculator onButtonClick={openModal} />
      <OccasionsSlider className="bg-white py-12" title="Other catering occasions" onButtonClick={openModal} />
    </Layout>
  )
}

function IntroGrid() {
  return (
    <OccasionPageGrid className="py-10">
      <OccasionPageGridRow
        heading="24 Hour Production Catering"
        content="Fuel your cast and crew with full meals or quick service items like coffee and snacks. We offer famous, on-trend food trucks that provide 24 hour production catering flexibility. Decide if you want buffet style service or order directly from the truck, and it's a wrap."
        image={filmProductionGrid1}
        reverse
      />
      <OccasionPageGridRow
        heading="Be the Star"
        content="Make the catering experience the center of your set's social scene by booking food trucks that the entire cast and crew will love. With thousands of well-known and delicious trucks in our network, we have the lobster roll or taco that everyone will go crazy for. You will be the biggest star on set."
        image={filmProductionGrid2}
      />
    </OccasionPageGrid>
  )
}

function WhyWorkWithUsGrid() {
  return (
    <OccasionPageGrid className="py-10">
      <OccasionPageGridRow
        heading="We Handle the Hard Part"
        content="Make feeding everyone on the lot the easiest part of your day. We reach out to the most reliable trucks, negotiate the best prices, and handle all the transactions. Just tell us what you want and we'll help you get back to more important tasks."
        image={filmProductionGrid3}
        reverse
      />
      <OccasionPageGridRow
        heading="Service Guarantee"
        content="Book your production catering with confidence knowing we have established relationships with the food trucks around the country. We hold all funds until after your event, so we can guarantee you will get fantastic customer service every time."
        image={filmProductionGrid4}
      />
    </OccasionPageGrid>
  )
}

function HowItWorksGrid() {
  return (
    <OccasionPageGrid className="pb-16">
      <OccasionPageGridRow
        heading="Craft Services, done right."
        content="Looking to expand your craft services options? Give your cast and crew a fresh acai bowl instead of that boring bagel. Choose from hundreds of grab-and-go food options, brought direct to your tv or movie set."
        image={filmProductionGrid5}
        reverse
      />
      <OccasionPageGridRow
        heading="It's A Wrap!"
        content="Celebrate your final production day or wrap party with the best food truck catering in Los Angeles. With thousands of well-known and delicious trucks in our network, we have the lobster roll or taco that everyone will go crazy for."
        image={filmProductionGrid6}
      />
    </OccasionPageGrid>
  )
}
